export default "__VITE_ASSET__CSkF$lho__"